

import pxToRem from "assets/theme-dark/functions/pxToRem";
import colors from "assets/theme-dark/base/colors";

const { transparent, light, white } = colors;


const select = {
  styleOverrides: {
    select: {
      "& .Mui-selected": {
        backgroundColor: transparent.main,
      },
    },
    icon:{
      color: white.main,
      "&:hover": {
        backgroundColor: transparent.main,
        color: light.main,
      },
      "&:disabled": {

        color: light.main,
      },
    },
  },
};

export default select;
